import { FC } from 'react';
import { ModeOption } from '../../utils/constants';
import { IClinicServicesOption } from '../../BookNowPanel';
import ContactLookup from '../ContactLookup/ContactLookup';
import Verification from '../Identity/Verification/Verification';
import SignIn from '../Identity/SignIn/SignIn';
import SignUp from '../Identity/SignUp/SignUp';
import ContactDetails from '../Identity/ContactDetails/ContactDetails';
import PatientSchedule from '../PatientSchedule/PatientSchedule';
import SlotSelection from '../SlotSelection/SlotSelection';
import { FamilyStep, STEPS } from 'redux/familyBookingSlice';

const {
  CONTACT_LOOKUP,
  VERIFICATION,
  SIGN_IN,
  SIGN_UP,
  CONTACT_DETAILS,
  SCHEDULE,
  SLOT_SELECTION,
} = STEPS;

interface FamilyBookingStepProps {
  currentStep: FamilyStep;
  mode: ModeOption;
  clinicServicesOptions: IClinicServicesOption[];
}

const FamilyBookingStep: FC<FamilyBookingStepProps> = ({
  currentStep,
  mode,
  clinicServicesOptions,
}) => {
  return (
    <>
      {currentStep === CONTACT_LOOKUP && <ContactLookup />}

      {currentStep === VERIFICATION && <Verification />}

      {currentStep === SIGN_IN && <SignIn />}

      {currentStep === SIGN_UP && <SignUp />}

      {currentStep === CONTACT_DETAILS && <ContactDetails />}

      {currentStep === SCHEDULE && (
        <PatientSchedule
          mode={mode}
          clinicServicesOptions={clinicServicesOptions}
        />
      )}

      {currentStep === SLOT_SELECTION && <SlotSelection />}
    </>
  );
};

export default FamilyBookingStep;
